import { OperationTypeNode } from "graphql";
import { TableName } from "src/lib/dexie-db/constants";
import extractRootResolver from "./extractRootResolver";
// Function to extract nodeId from GraphQL operation variables
const extractNodeIdFromQueryVariables = (() => {
    const queryNodeIdResolverMap = {
        ep_diagramSearch(_, variables) {
            return { nodeId: variables.ancestorID, tableName: TableName.QNA_NODE };
        },
        ep_questionDetails(_, variables) {
            return { nodeId: variables.questionID, tableName: TableName.QNA_NODE };
        },
        ep_questionListForQP(_, variables) {
            return { nodeId: variables.questionPaperID, tableName: TableName.QNA_NODE };
        },
        ep_questionListForTopic(_, variables) {
            return { nodeId: variables.ancestorID, tableName: TableName.QNA_NODE };
        },
        ep_questionTopicList(_, variables) {
            return { nodeId: variables.ancestorID, tableName: TableName.QNA_NODE };
        },
        ep_questionSearch(_, variables) {
            return { nodeId: variables.ancestorID, tableName: TableName.QNA_NODE };
        },
        ep_questionPlaylistForQP(_, variables) {
            return { nodeId: variables.questionPaperID, tableName: TableName.QNA_NODE };
        },
        ep_questionPlaylistForTopic(_, variables) {
            return { nodeId: variables.ancestorID, tableName: TableName.QNA_NODE };
        },
        ep_qp(_, variables) {
            return { nodeId: variables.qpID, tableName: TableName.QNA_NODE };
        },
        ep_qpList(_, variables) {
            return { nodeId: variables.subjectID, tableName: TableName.QNA_NODE };
        },
        ep_subjectDetails(_, variables) {
            return { nodeId: variables.subjectID, tableName: TableName.QNA_NODE };
        },
        ep_subjectList(_, variables) {
            return { nodeId: variables.examLevelID, tableName: TableName.QNA_NODE };
        },
        ep_examLevelList(_, variables) {
            return { nodeId: variables.communityID, tableName: TableName.QNA_NODE };
        },
        ep_examLevelDetails(_, variables) {
            return { nodeId: variables.examLevelID, tableName: TableName.QNA_NODE };
        },
        ep_communityDetails(_, variables) {
            return { nodeId: variables.communityID, tableName: TableName.QNA_NODE };
        },
        ep_communityList(_, variables) {
            return null; // No specific nodeId for list operations
        }
    };
    return (operation) => {
        const rootResolver = extractRootResolver(operation);
        if (!rootResolver || rootResolver.operationType !== OperationTypeNode.QUERY) {
            return null;
        }
        const queryNodeIdResolver = queryNodeIdResolverMap[rootResolver.operationName];
        if (!queryNodeIdResolver) {
            return null;
        }
        return queryNodeIdResolver(null, operation.variables);
    };
})();
export default extractNodeIdFromQueryVariables;
